
import Vue from 'vue'

import store from './lib/vuex'

// if (typeof Vue !== 'undefined') {
// } else {
//   console.warn('@store/v2 could not load Vue components, Vue is undefined')
// }

// 1. Create API Store Global Component, this component will import $store2 and enable HMR
Vue.component('ApiStore', require('./ApiStore'))

// 2. Register Global Sub-Components
Vue.component('StoreDemoViewer', require('./components/StoreDemoViewer'))

// 3. Export Vuex store so it can be imported by root Vuex module @store/index.js
export default store

// @todo Replace this with a Vue plugin
